// Validating the JSA V1 DEL
import * as jsaCoreValidation from "./jsa_validation/core";
import * as jsaV1Validation from "./jsa_validation/v1";

// Validating the JSA V1 DEL
export const validateJsaV1DelDraft = (jsa) => {
  const errors = {
    basicInfo: null,
    rac: null,
    training: null,
    employeeSignatures: null,
    nonEmployeeSignatures: null,
    confinedSpace: null,
  };

  // Validating the JSA Core items first
  const basicInfoErrors = jsaCoreValidation.validateJsaBasicInfoDraft(
    jsa.jsaBasicInfo
  );

  if (basicInfoErrors) {
    errors.basicInfo = basicInfoErrors;
  }

  // Validating the JSA RAC
  const racErrors = jsaCoreValidation.validateJsaRac(jsa.jsaRacInfo);

  if (racErrors) {
    errors.rac = racErrors;
  }

  // Validating the JSA Training, commented out since I don't think we will need it right now.
  // const trainingErrors = jsaCoreValidation.validateJsaTraining(
  //   jsa.jsaTrainingInfo
  // );

  // if (trainingErrors) {
  //   errors.training = trainingErrors;
  // }

  // Validating the JSA Employee Signatures
  const employeeSignaturesErrors =
    jsaCoreValidation.validateJsaEmployeeSignaturesDraft(
      jsa.jsaEmployeeSignaturesInfo
    );

  if (employeeSignaturesErrors) {
    errors.employeeSignatures = employeeSignaturesErrors;
  }

  // Validating the JSA Non Employee Signatures
  const nonEmployeeSignaturesErrors =
    jsaCoreValidation.validateJsaNonEmployeeSignaturesDraft(
      jsa.jsaNonEmployeeSignaturesInfo
    );

  if (nonEmployeeSignaturesErrors) {
    errors.nonEmployeeSignatures = nonEmployeeSignaturesErrors;
  }

  // Validating the V1 JSA Confined Space
  const confinedSpaceErrors = jsaV1Validation.validateJsaConfinedSpace(
    jsa.jsaConfinedSpace
  );

  if (confinedSpaceErrors) {
    errors.confinedSpace = confinedSpaceErrors;
  }

  return errors;
};

// Validating the JSA V1 DEL Submitted
export const validateJsaV1DelSubmitted = (jsa) => {
  const errors = {
    basicInfo: null,
    rac: null,
    training: null,
    employeeSignatures: null,
    nonEmployeeSignatures: null,
    confinedSpace: null,
  };

  // Validating the JSA Core items first
  const basicInfoErrors = jsaCoreValidation.validateJsaBasicInfoSubmitted(
    jsa.jsaBasicInfo
  );

  if (basicInfoErrors) {
    errors.basicInfo = basicInfoErrors;
  }

  // Validating the JSA RAC
  const racErrors = jsaCoreValidation.validateJsaRac(jsa.jsaRacInfo);

  if (racErrors) {
    errors.rac = racErrors;
  }

  // Validating the JSA Training
  const trainingErrors = jsaCoreValidation.validateJsaTraining(
    jsa.jsaTrainingInfo
  );

  if (trainingErrors) {
    errors.training = trainingErrors;
  }

  // Validating the JSA Employee Signatures
  const employeeSignaturesErrors =
    jsaCoreValidation.validateJsaEmployeeSignaturesSubmitted(
      jsa.jsaEmployeeSignaturesInfo
    );

  if (employeeSignaturesErrors) {
    errors.employeeSignatures = employeeSignaturesErrors;

    // Validating the JSA Non Employee Signatures
    const nonEmployeeSignaturesErrors =
      jsaCoreValidation.validateJsaNonEmployeeSignaturesSubmitted(
        jsa.jsaNonEmployeeSignaturesInfo
      );

    if (nonEmployeeSignaturesErrors) {
      errors.nonEmployeeSignatures = nonEmployeeSignaturesErrors;
    }

    // Validating the V1 JSA Confined Space
    const confinedSpaceErrors = jsaV1Validation.validateJsaConfinedSpace(
      jsa.jsaConfinedSpace
    );

    if (confinedSpaceErrors) {
      errors.confinedSpace = confinedSpaceErrors;
    }

    return errors;
  }
};
